import { FeatureFlag, useFeatureFlagsStore } from 'stores/featureFlagsStore';

export function useSourcingNoteFilter(): boolean {
  return useFeatureFlagsStore((state) =>
    state.isFeatureEnabled(FeatureFlag.sourcing_note_filter)
  );
}
